import React from 'react'
import Layout from '@/shared/components/organisms/layout/layout'
import useMediaQuery from '@/hooks/useMediaQuery'
import AppSeo from '@/components/atoms/app-seo/app-seo'
import ModalViewer from '@/components/organisms/modal-viewer/modal-viewer'
import './page-layout.scss'
import { IBaseProps } from '@/interfaces/common.interface'

const PageLayout = ({ children }: IBaseProps) => {
  let isMobile = useMediaQuery()
  return (
    <Layout mobile={isMobile}>
      <AppSeo />
      {children}
      <ModalViewer />
    </Layout>
  )
}

export default PageLayout
